export default "__VITE_ASSET__26691ff2__"